var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time_icon_tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "access_time-black-18dp",
    transform: "translate(0.733333, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 25 0 25 25 0 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9206897,1.72413793 C7.21034483,1.72413793 2.5862069,6.35862069 2.5862069,12.0689655 C2.5862069,17.7793103 7.21034483,22.4137931 12.9206897,22.4137931 C18.6413793,22.4137931 23.2758621,17.7793103 23.2758621,12.0689655 C23.2758621,6.35862069 18.6413793,1.72413793 12.9206897,1.72413793 Z M12.9310345,20.3448276 C8.35862069,20.3448276 4.65517241,16.6413793 4.65517241,12.0689655 C4.65517241,7.49655172 8.35862069,3.79310345 12.9310345,3.79310345 C17.5034483,3.79310345 21.2068966,7.49655172 21.2068966,12.0689655 C21.2068966,16.6413793 17.5034483,20.3448276 12.9310345,20.3448276 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "12.7155172 7.75862069 11.2068966 7.75862069 11.2068966 13.9768231 16.487069 17.2413793 17.2413793 15.9666478 12.7155172 13.1995478"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.79409b3eec8a80382b9f7dd55db7886f.svg";
export { ForwardRef as ReactComponent };